import { ModulesService } from './../modules.service';
import { Component, OnInit } from '@angular/core';
import { CataloguesService } from '../catalogues.service';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.css']
})
export class ModulesComponent implements OnInit {

  //declare variables
  modules: any[] = [];
  regs: any[] = [];

  //inject services
  constructor(private ms: ModulesService, private cs: CataloguesService, private mds: MetaService) { }

  //initialize component
  ngOnInit(): void {
    //retrieve data
    this.modules = this.ms.getModuleList();
    this.regs = this.cs.getCatalogList();

    //SEO Optimization
    var strTitle = 'RegScale - Modules';
    var description = 'RegScale modules for our multi-tenant compliance cloud platform';
    var keywords = 'RegScale, audits/assessments, assets, causal analysis, data calls, exceptions, incidents, issues, POAMs, policies, projects, requirements, risks, cyber security, supply chain, threats';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
